
/**
 * Inserts HTML content into the Word document at the current cursor selection.
 * This function uses the Office.js API and will only work when run inside a Word Add-in.
 * @param {string} html The HTML content to insert.
 * @returns {Promise<void>} A promise that resolves when the insertion is complete.
 * @throws {Error} Throws an error if not in a Word environment or if the insertion fails.
 */
export async function insertContentIntoWord(html) {
  // First, check if we are actually inside an Office Add-in.
  if (!window.Office || !window.Word) {
    const errorMessage = "This feature is only available within a Microsoft Word Add-in.";
    console.error(errorMessage);
    // We throw an error so the calling component knows it failed.
    throw new Error(errorMessage);
  }

  const styledHtml = `<style>
                        table { border-collapse: collapse; width: 100%; }
                        th, td { border: 1px solid black; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                        img { max-width: 100%; height: auto; display: block; margin: 10px auto; }
                      </style>
                      ${html}
                      <p>&nbsp;</p>`;

  try {
    // Use the Word.run API to interact with the document.
    await window.Word.run(async (context) => {
      const selection = context.document.getSelection();
      selection.insertHtml(styledHtml, window.Word.InsertLocation.replace);
      await context.sync();
    });
  } catch (error) {
    console.error("Error during content insertion:", error);
    // Re-throw the error with a more user-friendly message.
    throw new Error("Could not insert content. Please ensure the document is editable and try again.");
  }
}



